import { Link } from 'react-router-dom';
import Xed21Logo from '../brand/Xed21Logo';

const LINKEDIN_URL = 'https://www.linkedin.com/company/xed21';

export default function Footer() {
  return (
    <footer className="bg-slate-50 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <Xed21Logo size="md" className="mb-4" />
            <p className="text-sm text-slate-500 leading-relaxed max-w-xs">
              AI question generation for NCERT-aligned classrooms, with
              Bloom's Taxonomy built into every paper.
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a
                href={LINKEDIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow Xed21 on LinkedIn"
                className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-slate-100 text-slate-500 hover:bg-teal-50 hover:text-teal-700 transition-colors"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              <a
                href="mailto:contact@xed21.com"
                aria-label="Email Xed21"
                className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-slate-100 text-slate-500 hover:bg-teal-50 hover:text-teal-700 transition-colors"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h2 className="text-sm font-semibold text-slate-900 mb-4">
              Product
            </h2>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/generator"
                  className="text-sm text-slate-500 hover:text-teal-600 transition-colors"
                >
                  Generator
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-sm text-slate-500 hover:text-teal-600 transition-colors"
                >
                  Teacher Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm text-slate-500 hover:text-teal-600 transition-colors"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/assessments"
                  className="text-sm text-slate-500 hover:text-teal-600 transition-colors"
                >
                  Assessments
                </Link>
              </li>
              <li>
                <a
                  href="/#features"
                  className="text-sm text-slate-500 hover:text-teal-600 transition-colors"
                >
                  Features
                </a>
              </li>
              <li>
                <a
                  href="/#faq"
                  className="text-sm text-slate-500 hover:text-teal-600 transition-colors"
                >
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-sm font-semibold text-slate-900 mb-4">
              Board Availability
            </h2>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-slate-500">NCERT / CBSE</span></li>
              <li>
                <a
                  href="/#board-waitlist"
                  className="text-sm text-slate-500 hover:text-teal-600 transition-colors"
                >
                  ICSE, IB, State Boards Waitlist
                </a>
              </li>
            </ul>

            <h2 className="text-sm font-semibold text-slate-900 mb-4 mt-6">
              Connect
            </h2>
            <ul className="space-y-2.5">
              <li>
                <a
                  href={LINKEDIN_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-slate-500 hover:text-teal-600 transition-colors"
                >
                  LinkedIn
                </a>
              </li>
              <li>
                <a
                  href="mailto:contact@xed21.com"
                  className="text-sm text-slate-500 hover:text-teal-600 transition-colors"
                >
                  contact@xed21.com
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-sm font-semibold text-slate-900 mb-4">
              Account
            </h2>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/auth"
                  className="text-sm text-slate-500 hover:text-teal-600 transition-colors"
                >
                  Sign In
                </Link>
              </li>
              <li>
                <Link
                  to="/auth"
                  className="text-sm text-slate-500 hover:text-teal-600 transition-colors"
                >
                  Create Account
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-200 mt-10 pt-6 text-center">
          <p className="text-sm text-slate-600">
            &copy; {new Date().getFullYear()} Xed21. Built for educators,
            powered by AI. Contact{' '}
            <a href="mailto:contact@xed21.com" className="font-medium text-teal-700 hover:text-teal-800">
              contact@xed21.com
            </a>
            .
          </p>
        </div>
      </div>
    </footer>
  );
}
